import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionProyectoResponsablesUsuarioComponent {
  onClose
  usuario = undefined
  correo = undefined
  usuarios

  agregar() {
    this.onClose({$event: {detail: {usuario: {usuario: this.usuario, correo: this.correo}}}})
  }

  cerrar() {
    this.onClose()
  }
}

module.component('viaticosConfiguracionProyectoResponsablesUsuario', {
  controller: ViaticosConfiguracionProyectoResponsablesUsuarioComponent,
  template,
  bindings: {
    usuarios: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyecto/responsables/usuario/component.js